import React, { Fragment, useEffect } from "react";
import { Pagina } from "../template/Template";
import { AuthContext } from "../../App";
import Paper from "@material-ui/core/Paper";
import { Loading } from "../Loading";
import { ShowMessageBox } from "../ShowMessageBox";
import { monitorDados } from "../../services/MonitorService";
import IconButton from "@material-ui/core/IconButton";
import Autorenew from "@material-ui/icons/Autorenew";
import Slider from "@material-ui/core/Slider";

import * as moment from "moment";

import { useStyles } from "../styles/StyleMonitoracao";

let severity = "success";
let msg = "";
let interval;

export default function Monitoracao() {
    const classes = useStyles();
    const { state: authState } = React.useContext(AuthContext);

    const [listMonitor, setListMonitor] = React.useState([]);
    const [openSnackBar, setOpenSnackBar] = React.useState(false);
    const [openLoading, setOpenLoading] = React.useState(false);
    const [value, setValue] = React.useState(5);

    function valuetext(value) {
        setValue(value);
        return `${value} Min`;
    }

    function newInterval(newValue) {
        clearInterval(interval);
        interval = setInterval(async function () {
            atualizarDados();
        }, newValue * 60 * 1000);
        setValue(newValue);
    }

    useEffect(() => {
        interval = setInterval(function () {
            atualizarDados();
        }, value * 60 * 1000);
        atualizarDados();
        return () => {
            clearInterval(interval);
        };
    }, []);

    const atualizarDados = async () => {
        setOpenLoading(true);
        try {
            const respMonitor = await monitorDados();
            setListMonitor(respMonitor.data);
        } catch (error) {
            msg = "Erro na leitura dos dados de Monitoramento";
            severity = "error";
            setOpenSnackBar(true);
            console.log(error);
        }
        setOpenLoading(false);
    };

    const Content = () => {
        const marks = [
            {
                value: 1,
                label: "1 Min",
            },
            {
                value: 2,
                label: "2 Min",
            },
            {
                value: 3,
                label: "3 Min",
            },
            {
                value: 4,
                label: "4 Min",
            },
            {
                value: 5,
                label: "5 Min",
            },
        ];
        return (
            <Fragment>
                <ShowMessageBox
                    open={openSnackBar}
                    setOpen={setOpenSnackBar}
                    severity={severity}
                    msg={msg}
                />

                <Loading open={openLoading} />

                <div className={classes.box}>
                    <Paper className={classes.boxPrancheta} elevation={7}>
                        <div className={classes.boxHeader}>
                            <div className={classes.boxHeaderItens}>
                                <Slider
                                    defaultValue={5}
                                    getAriaValueText={valuetext}
                                    aria-labelledby="discrete-slider"
                                    valueLabelDisplay="auto"
                                    step={1}
                                    value={value}
                                    onChange={(e, val) => newInterval(val)}
                                    marks={marks}
                                    min={1}
                                    max={5}
                                    style={{ width: "250px" }}
                                    component="span"
                                />
                                <IconButton
                                    color="primary"
                                    aria-label="Atualizar"
                                    component="span"
                                    onClick={atualizarDados}
                                >
                                    <Autorenew />
                                </IconButton>
                            </div>
                        </div>
                        <div className={classes.boxDataGrid}>
                            {listMonitor.map((sites) => (
                                <div
                                    style={{ width: "400px", height: "250px", fontSize: "120%" }}
                                >
                                    <Paper
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "flexStart",
                                            textAlign: "center",
                                            overflow: "auto",
                                        }}
                                        elevation={4}
                                    >
                                        <table style={{ width: "100%" }}>
                                            <tr
                                                className={
                                                    sites.mos_monitor === "N"
                                                        ? classes.normalHead
                                                        : sites.mos_monitor === "W"
                                                            ? classes.yellowHead
                                                            : classes.redLine
                                                }
                                                style={{ width: "100%", fontSize: "110%" }}
                                            >
                                                <td colspan="4">
                                                    {sites.sit_nome} atualizado em:{" "}
                                                    {sites.mos_monitor_data === null
                                                        ? "Nunca"
                                                        : moment(sites.mos_monitor_data).format(
                                                            "DD/MM/YY-HH:mm"
                                                        )}
                                                </td>
                                            </tr>
                                            <tr
                                                className={
                                                    sites.mos_monitor === "N"
                                                        ? classes.normalHead
                                                        : sites.mos_monitor === "W"
                                                            ? classes.yellowHead
                                                            : classes.redLine
                                                }
                                                style={{ width: "100%", fontSize: "110%" }}
                                            >
                                                <td colspan="4">
                                                    {sites.mos_origem === null
                                                        ? "Nunca"
                                                        : sites.mos_origem}
                                                </td>
                                            </tr>

                                            {sites.dados.length > 1 ? (
                                                sites.dados.map((site) => (
                                                    <tr
                                                        className={
                                                            site.mnl_monitor === "N"
                                                                ? classes.normalLine
                                                                : site.mnl_monitor === "W"
                                                                    ? classes.yellowLine
                                                                    : classes.redLine
                                                        }
                                                        style={{ fontSize: "80%" }}
                                                    >
                                                        <td>{site.mot_id}</td>
                                                        <td>
                                                            {site.mot_id === "PING"
                                                                ? site.mav_app
                                                                : site.mnl_id}
                                                        </td>
                                                        <td>
                                                            {site.mot_id === "PING"
                                                                ? moment(site.mnl_data_base).format(
                                                                    "DD/MM/YY-HH:mm"
                                                                ) +
                                                                "/" +
                                                                site.mnl_versao
                                                                : site.mot_id === "CONTAINER"
                                                                    ? site.mnl_data === null
                                                                        ? "Nunca"
                                                                        : moment(site.mnl_data).format(
                                                                            "DD/MM/YY-HH:mm"
                                                                        )
                                                                    : site.mnl_valor_total +
                                                                    "/" +
                                                                    site.mnl_valor_free}
                                                        </td>
                                                        <td>{site.mnl_limite}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td>
                                                        <h1>Nenhum dado encontrado</h1>
                                                    </td>
                                                </tr>
                                            )}
                                        </table>
                                    </Paper>
                                </div>
                            ))}
                        </div>
                    </Paper>
                </div>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Pagina
                authState={authState}
                Content={Content}
                HeaderDesc="MONITORAMENTO"
            />
        </Fragment>
    );
}
